<template>
		<div class="content home-page">
      <Header></Header>
			<div class="information mt100 crfff ac por">
        <div class="fs50">{{$t('language')}}</div>
        <div class="fs26 mt30 cr0062ff">{{$t('languageTips')}} :</div>
          <div class="change-list change-list2 ac">
            <div class="one" @click="getLang(2,'en')" :class="{'active':isShow=='en'}">
              <img class="dui" src="../../static/images/dui.png">
              <img style="width:100px" :src="isShow=='en'?'../../static/images/en.jpg':'../../static/images/en.jpg'" />
              <span>{{$t('English')}}</span>
            </div>
            <div class="one" @click="getLang(2,'bur')" :class="{'active':isShow=='bur'}">
              <img class="dui" src="../../static/images/dui.png">
              <img style="width:100px" :src="isShow=='bur'?'../../static/images/en1.jpg':'../../static/images/en1.jpg'" />
              <span>{{$t('Myanmar')}}</span>
            </div>
          </div>
        <div class="ac mt50">
          <button class="button fw7" @click="getLang(1)">{{$t('change')}}</button>
        </div>
			</div>
		</div>
</template>
<script>
import Header from '../components/HeaderTwo'
export default {
    components:{
      Header
    },
    data() {
      return {
        list:[],
        lang:'',
        isShow:'bur',
      }
    },
	created(){
    if(localStorage.getItem('lang')){
      this.isShow = localStorage.getItem('lang')
    }
	},
    methods: {
      back(){
        this.$router.go(-1);
      },
      getLang(type,lang){
        if(type==1){
          localStorage.setItem('lang',this.lang)
          this.$router.push({path:'/',query:{}});
          location.reload()
        }else{
          this.isShow = lang
          this.lang = lang
        }
      },
    }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/language.vue